// AUTH
export const PHONE_NUMBER_REQUEST = "PHONE_NUMBER_REQUEST";
export const LOGIN_BUTTON_REQUEST = "LOGIN_BUTTON_REQUEST";
export const LOGIN_BUTTON_ERROR = "LOGIN_BUTTON_ERROR";
export const LOGIN_BUTTON_SUCCESS = "LOGIN_BUTTON_SUCCESS";
export const RESET_LOGIN_VALUE = "p2p/RESET_LOGIN_VALUE";
export const DO_LOGIN = "p2p/DO_LOGIN";
export const DO_LOGIN_SUCCESS = "p2p/DO_LOGIN_SUCCESS";
export const DO_LOGIN_ERROR = "p2p/DO_LOGIN_ERROR";
export const GET_REFERRAL_CODE = "p2p/GET_REFERRAL_CODE";
export const IS_REFERAL_MODAL = "p2p/IS_REFERAL_MODAL";
export const GET_REFERRAL_CODE_PENDING = "GET_REFERRAL_CODE_PENDING";
export const GET_REFERRAL_CODE_SUCCESS = "GET_REFERRAL_CODE_SUCCESS";
export const GET_REFERRAL_CODE_ERROR = "GET_REFERRAL_CODE_ERROR";
export const CHECK_MOBILE_FIELD_FOCUS = "CHECK_MOBILE_FIELD_FOCUS";
export const HANDLE_CHECKBOX = "HANDLE_CHECKBOX";
export const GET_CUSTOMER_DETAILS = "GET_CUSTOMER_DETAILS";
export const GET_CUSTOMER_DETAILS_SUCCESS = "GET_CUSTOMER_DETAILS_SUCCESS";
export const GET_CUSTOMER_DETAILS_ERROR = "GET_CUSTOMER_DETAILS_ERROR";

//
export const GET_PORTFOLIO_REQ = "GET_PORTFOLIO_REQ";
export const GET_PORTFOLIO_ERROR = "GET_PORTFOLIO_ERROR";
export const GET_PORTFOLIO_SUCCESS = "GET_PORTFOLIO_SUCCESS";

//check kyc status
export const CHECK_KYC_STATUS = "CHECK_KYC_STATUS";

/// userinfo
export const GET_USER_STATUS_REQUEST = "GET_USER_STATUS_REQUEST";
export const GET_USER_STATUS_REQUEST_SUCCESS = "GET_USER_STATUS_REQUEST_SUCCESS";
export const GET_USER_STATUS_REQUEST_ERROR = "GET_USER_STATUS_REQUEST_ERROR";

/// userinfo
export const GET_LDC_REQUEST = "GET_LDC_REQUEST";
export const GET_LDC_SUCCESS = "GET_LDC_SUCCESS";
export const GET_LDC_ERROR = "GET_LDC_ERROR";
export const CONFIRM_OTP_REQUEST = "CONFIRM_OTP_REQUEST";
export const CONFIRM_OTP_SUCCESS = "CONFIRM_OTP_SUCCESS";
export const CONFIRM_OTP_ERROR = "CONFIRM_OTP_ERROR";

// personal information
export const PERSONAL_INFO_REQ_VALUE = "PERSONAL_INFO_REQ_VALUE";
export const PERSONAL_INFO_REQUEST = "PERSONAL_INFO_REQUEST";
export const PERSONAL_INFO_ERROR = "PERSONAL_INFO_ERROR";
export const PERSONAL_INFO_SUCCESS = "PERSONAL_INFO_SUCCESS";
export const PERSONAL_INFO_DETAILS_REQUEST = "PERSONAL_INFO_DETAILS_REQUEST";
export const PERSONAL_INFO_DETAILS_SUCCESS = "PERSONAL_INFO_DETAILS_SUCCESS";
export const PERSONAL_INFO_DETAILS_ERROR = "PERSONAL_INFO_DETAILS_ERROR";
export const PERSONAL_INFO_RESET_VALUE = "PERSONAL_INFO_RESET_VALUE";
export const GET_KYC_FROM_BACKEND = "GET_KYC_FROM_BACKEND";
export const GET_KYC_FROM_BACKEND_SUCCESS = "GET_KYC_FROM_BACKEND_SUCCESS";
export const GET_KYC_FROM_BACKEND_ERROR = "GET_KYC_FROM_BACKEND_ERROR";
export const PERSONAL_INFO_REQUEST_SECOND = "PERSONAL_INFO_REQUEST_SECOND";
export const PERSONAL_INFO_SEND_DETAILS_SUCCESS = "PERSONAL_INFO_SEND_DETAILS_SUCCESS";
export const PERSONAL_INFO_SEND_DETAILS_ERROR = "PERSONAL_INFO_SEND_DETAILS_ERROR";
export const PERSONAL_INFO_SEND_DETAILS_RESET = "PERSONAL_INFO_SEND_DETAILS_RESET";
// ckyc
export const CKYC_DATA_REQUEST = "CKYC_DATA_REQUEST";
export const CKYC_DATA_ERROR = "CKYC_DATA_ERROR";
export const CKYC_DATA_SUCCESS = "CKYC_DATA_SUCCESS";
export const GET_INPUT_IFSC_CODE = "GET_INPUT_IFSC_CODE";
export const FETCH_IFSC_CODE_REQUEST = "FETCH_IFSC_CODE_REQUEST";
export const FETCH_IFSC_CODE_SUCCESS = "FETCH_IFSC_CODE_SUCCESS";
export const FETCH_IFSC_CODE_ERROR = "FETCH_IFSC_CODE_ERROR";
export const FETCH_IFSC_CODE_RESET = "FETCH_IFSC_CODE_RESET";
export const CONNECT_FETCH_KYC_REQUEST = "CONNECT_FETCH_KYC_REQUEST";
export const CONNECT_FETCH_KYC_SUCCESS = "CONNECT_FETCH_KYC_SUCCESS";
export const CONNECT_FETCH_KYC_ERROR = "CONNECT_FETCH_KYC_ERROR";
export const CKYC_CONFIRMATION_REQUEST = "CKYC_CONFIRMATION_REQUEST";
export const CKYC_CONFIRMATION_SUCCESS = "CKYC_CONFIRMATION_SUCCESS";
export const CKYC_CONFIRMATION_ERROR = "CKYC_CONFIRMATION_ERROR";

// manual kyc
export const GET_MANUAL_KYC_IMAGE = "GET_MANUAL_KYC_IMAGE";
export const GET_MANUAL_KYC_REQ = "GET_MANUAL_KYC_REQ";
export const GET_MANUAL_KYC_SUCCESS = "GET_MANUAL_KYC_SUCCESS";
export const GET_MANUAL_KYC_ERROR = "GET_MANUAL_KYC_ERROR";
export const GET_MANUAL_KYC_IMAGE_RESET = "GET_MANUAL_KYC_IMAGE_RESET";

// adharcard kyc
export const GET_ADHAR_CARD_KYC_IMAGE = "GET_ADHAR_CARD_KYC_IMAGE";
export const GET_ADHAR_CARD_KYC_REQ = "GET_ADHAR_CARD_KYC_REQ";
export const GET_ADHAR_CARD_SUCCESS = "GET_ADHAR_CARD_SUCCESS";
export const ADHAR_CARD_ERROR = "ADHAR_CARD_ERROR";
export const GET_ADHAR_CARD_IMAGE_RESET = "GET_ADHAR_CARD_IMAGE_RESET";

// Gateway
export const PAYMENT_GATEWAY_REQ = "PAYMENT_GATEWAY_REQ";
export const PAYMENT_GATEWAY_SUCCESS = "PAYMENT_GATEWAY_SUCCESS";
export const PAYMENT_GATEWAY_ERROR = "PAYMENT_GATEWAY_ERROR";
export const PAYMENT_GATEWAY_RESET_VALUE = "PAYMENT_GATEWAY_RESET_VALUE";

// CONFIRMATION
export const TRANSACTION_CONFIRMATION_REQUEST ="TRANSACTION_CONFIRMATION_REQUEST";
export const TRANSACTION_CONFIRMATION_SUCCESS = "TRANSACTION_CONFIRMATION_SUCCESS";
export const TRANSACTION_CONFIRMATION_ERROR = "TRANSACTION_CONFIRMATION_ERROR";

// add money
export const ADD_MONEY_VALUE ="ADD_MONEY_VALUE";

// LENDER
export const LENDER_AGREEMENT = "LENDER_AGREEMENT";
export const LENDER_AGREEMENT_SUCCESS = "LENDER_AGREEMENT_SUCCESS";
export const LENDER_AGREEMENT_ERROR = "LENDER_AGREEMENT_ERROR"

// lender update
export const UPDATE_AGREEMENT = "UPDATE_AGREEMENT";
export const UPDATE_AGREEMENT_SUCCESS = "UPDATE_AGREEMENT_SUCCESS";
export const UPDATE_AGREEMENT_ERROR = "UPDATE_AGREEMENT_ERROR";

// 
export const FETCH_BANK_DETAIL = "FETCH_BANK_DETAIL";
export const FETCH_BANK_DETAIL_SUCCESS = "FETCH_BANK_DETAIL_SUCCESS";
export const FETCH_BANK_DETAIL_ERROR = "FETCH_BANK_DETAIL_ERROR";

// FAQ 
export const RAISE_TICKET_REQUEST = "RAISE_TICKET_REQUEST";
export const RAISE_TICKET_SUCCESS = "RAISE_TICKET_SUCCESS";
export const RAISE_TICKET_ERROR = "RAISE_TICKET_ERRRO";
export const RAISE_TICKET_ERROR_RESET = "RAISE_TICKET_ERROR_RESET";